import { render, staticRenderFns } from "./Graph.vue?vue&type=template&id=95747f32"
import script from "./Graph.vue?vue&type=script&lang=js"
export * from "./Graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95747f32')) {
      api.createRecord('95747f32', component.options)
    } else {
      api.reload('95747f32', component.options)
    }
    module.hot.accept("./Graph.vue?vue&type=template&id=95747f32", function () {
      api.rerender('95747f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/Graph.vue"
export default component.exports